import { CARE_DASHBOARD_PATH, CARE_DASHBOARD_STATUS_PATH } from 'ui/Care/paths';
import { BASE_COVID_PROXY_PATH } from 'ui/Covid/paths';
import {
  DEPRECATED_COVID_USER_DASHBOARD_ROOT_PATH,
  DEPRECATED_COVID_USER_TEST_STATUS_PATH,
} from 'ui/Covid/UserDashboard/paths';

// ReactRouter Redirects using `from` prop only works for `Switch` children.
// See https://reacttraining.com/react-router/web/api/Redirect/from-string
// Intended to be rendered inside AppRoutes.
export const REDIRECT_PATHS = [
  // All COVID kit activation is disabled, so we redirect to the dashboard now.
  {
    fromPaths: ['/covid-activate'],
    to: CARE_DASHBOARD_PATH,
  },
  {
    fromPaths: ['/covid-test', '/covid-results', '/covid/results'],
    to: BASE_COVID_PROXY_PATH,
  },
  // WARNING: We have sent emails to a number of our users referencing `/covid/dashboard`.
  // See commit 253c6b5d65e15a82faadda629a509b9b466568ca
  // We *must* keep redirects to ensure that links in already-sent emails work.
  // DO NOT DELETE these redirects.
  {
    fromPaths: [DEPRECATED_COVID_USER_DASHBOARD_ROOT_PATH],
    to: CARE_DASHBOARD_PATH,
  },
  {
    fromPaths: [DEPRECATED_COVID_USER_TEST_STATUS_PATH],
    to: CARE_DASHBOARD_STATUS_PATH,
  },
];
